// import styled from "styled-components";
// import PageTopTitle from "../../components/shared/PageTopTitle";
// import { useCallback, useEffect, useRef, useState } from "react";
// import { useDispatch } from "react-redux";
// import { getYukbulMessages, getYukbulMessagesCount, setYukBulSelectedMessages } from "../../features/admin5/admin5Slice";
// import { useSelector } from "react-redux";
// import avatar from "../../images/img/avatar.jpg";
// import moment from "moment";
// import Btn from "../../components/shared/button/Btn";
// import { BsCheckLg } from "react-icons/bs";
// import { clearPhoneNumbersForNotification } from "../../features/admin4/admin4Slice";
// import { showModal } from "../../features/modal/modalSlice";
// import InputSelectCity from "../../components/shared/input/new/InputSelectCity";
// import InputText from "../../components/shared/input/new/InputText";

// const Container = styled.div`
//   width: 100%;
//   .wrapper {
//     display: flex;
//     flex-direction: column;
//     width: 100%;
//     .content {
//       width: calc(100% - 60px);
//       margin: 30px;
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       .top-container{
//         width: 80%;
//         display: flex;
//         justify-content: space-between;
//         align-items: center;
//         gap: 10px;
//         color: ${({theme}) => theme.mainTextColor};
//         margin-bottom: 20px;
//         .filter-grp{
//             display: flex;
//             align-items: center;
//             gap: 20px;
//             .left-side{
//                 padding: 10px;
//                 display: flex;
//                 justify-content: center;
//                 align-items: center;
//                 width: 60px;
//                 height: 60px;
//                 font-size: var(--font-size-sm);
//                 font-weight: var(--font-weight-lg);
//             }
//         }
//         .right-side{
//             display: flex;
//             align-items: center;
//             gap: 20px;
//             .info-text{
//                 font-size: var(--font-size-sm);
//                 font-weight: var(--font-weight-lg);
//             }
//         }
//       }
//       .list{
//         width: 80%;
//         display: flex;
//         flex-direction: column;
//         gap: 10px;
//         color: ${({theme}) => theme.mainTextColor};
//         .list-item{
//             display: flex;
//             align-items: center;
//             width: 100%;
//             height: 100%;
//             border-radius: 10px;
//             .left-side{
//                 padding: 10px;
//                 display: flex;
//                 justify-content: center;
//                 align-items: center;
//                 width: 60px;
//                 height: 60px;
//                 .check-container{
//                     display: flex;
//                     justify-content: center;
//                     align-items: center;
//                     width: 25px;
//                     height: 25px;
//                     border-radius: 50%;
//                     border: 1px solid ${({theme}) => theme.secondaryTextColor};
//                     background-color: ${({theme}) => theme.mainBgColor};
//                     .check-icon{
//                         font-size: 1rem;
//                         color: ${({theme}) => theme.secondaryTextColor};
//                     }
//                 }
//                 .active-check-container{
//                     display: flex;
//                     justify-content: center;
//                     align-items: center;
//                     width: 25px;
//                     height: 25px;
//                     border-radius: 50%;
//                     border: 1px solid var(--color-main);
//                     background-color: var(--color-main);
//                     .check-icon{
//                         font-size: 1rem;
//                         color: #fff;
//                     }
//                 }
//             }
//             .right-side{
//                 width: calc(100% - 60px);
//                 display: flex;
//                 align-items: center;
//                 gap: 10px;
//                 background-color: ${({theme}) => theme.secondaryBgColor};
//                 padding: 20px;
//                 border-radius: 10px;
//                 position: relative;
//                 img{
//                     width: 50px;
//                     height: 50px;
//                     border-radius: 50%;
//                     object-fit: cover;
//                 }
//                 .content-wrapper{
//                     display: flex;
//                     flex-direction: column;
//                     gap: 10px;
//                     color: ${({theme}) => theme.mainTextColor};
//                     .phone-number{
//                         font-size: 13px;
//                         font-weight: var(--font-weight-xl);
//                         color: var(--color-main);
//                     }
//                     .message-text{
//                         font-size: var(--font-size-sm);
//                         font-weight: var(--font-weight-lg);
//                     }
//                     .date{
//                         font-size: 13px;
//                         font-weight: var(--font-weight-lg);
//                     }
//                 }
//                 .activator{
//                     position: absolute;
//                     height: 100%;
//                     right: 0;
//                     top: 0;
//                     bottom: 0;
//                     width: 8px;
//                     background-color: var(--color-main);
//                     border-top-right-radius: 10px;
//                     border-bottom-right-radius: 10px;
//                 }
//             }
//         }
//       }
//   }}
// `;
// const highlightText = (text, searchTerms) => {
//   // if (typeof text !== 'string' || !searchTerms || searchTerms.length === 0) return text; // Eğer text string değilse veya searchTerms boşsa orijinal metni döndür

//   // `searchTerms` içinde her iki arama terimini vurgulayacağız.
//   let highlightedText = text;
//   console.log(searchTerms);

//   const filtered = searchTerms.filter(item => item !== "")
  

//   filtered.forEach((search) => {
//     const regex = new RegExp(`(${search})`, 'gi'); // 'gi' global ve case-insensitive
//     highlightedText = highlightedText.replace(regex, (match) => `<span style="background-color: yellow">${match}</span>`);
//   });

//   return highlightedText;
// };

// const formatData = (data, filterText, filterCity) => {
//   // if (typeof data !== 'string') data = String(data); // Mesajın string olduğundan emin olalım

//   // Hem filterText hem de filterCity'yi vurgulamak için
//   const searchTerms = [filterText.toLocaleLowerCase("tr"), filterCity.toLocaleLowerCase("tr")]; // Arama kelimelerini bir array'de toplayalım
//   const formattedText = highlightText(data.toLocaleLowerCase("tr"), searchTerms); // İki kelimeyi aynı anda vurgulamak için

//   return <span dangerouslySetInnerHTML={{ __html: formattedText }} />;
// };

// const YukBul = () => {
//   const dispatch = useDispatch();
//   const { allYukbulMessages, yukBulSelectedMessages, isLoadingGetYukbulMessages, allYukbulMessagesCount } = useSelector(state => state.admin5);
//   const [filterCity, setFilterCity] = useState(null);
//   const [filterText, setFilterText] = useState("");

//   const observer = useRef();

//   console.log(filterText, filterCity);
  

//   useEffect(() => {
//     // İlk 200 öğeyi getiren API isteği
//     dispatch(getYukbulMessages({
//       size: 200,
//       filterCity: filterCity?.value,
//       filterText: filterText,
//     }));
//     dispatch(getYukbulMessagesCount({
//       filterCity: filterCity?.value,
//       filterText: filterText,
//     }));
//   }, [dispatch, filterCity, filterText]);

//   const lastItemElementRef = useCallback(node => {
//     if (observer.current) observer.current.disconnect();

//     observer.current = new IntersectionObserver(entries => {
//       if (entries[0].isIntersecting && !isLoadingGetYukbulMessages && allYukbulMessagesCount > allYukbulMessages.length) {
//         dispatch(getYukbulMessages({
//           size: ((allYukbulMessages.length / 200) + 1) * 200,
//           filterCity: filterCity?.value,
//           filterText: filterText,
//         }));
//         dispatch(getYukbulMessagesCount({
//           filterCity: filterCity?.value,
//           filterText: filterText,
//         }));
//       }
//     });

//     if (node) observer.current.observe(node);
//   }, [dispatch, isLoadingGetYukbulMessages, allYukbulMessages.length, filterCity, filterText, allYukbulMessagesCount]);

//   return (
//     <Container>
//       <div className="wrapper">
//         <PageTopTitle title={"Yük Bul"} position="sticky" />
//         <div className="content">
//           <div className="top-container">
//             <div className="filter-grp">
//               <div className="left-side">Seç</div>
//               <InputSelectCity data={filterCity?.value} setData={setFilterCity} name={"filterCity"} labelText={"İle Göre Filtrele"} />
//               <InputText data={filterText} setData={(e) => setFilterText(e.target.value)} name={"workCity"} labelText={"Metne Göre Filtrele"} />
//             </div>
//           </div>
//           <div className="list">
//             {
//               allYukbulMessages.map((item, index) => {
//                 return (
//                   <div
//                     className="list-item"
//                     ref={index === allYukbulMessages.length - 1 ? lastItemElementRef : null}
//                     key={index}
//                   >
//                     <div className="left-side">
//                       <button className={yukBulSelectedMessages.map(item => item.id).includes(item.id) ? "active-check-container" : "check-container"} onClick={() => dispatch(setYukBulSelectedMessages({ id: item.id }))}>
//                         <BsCheckLg className="check-icon" />
//                       </button>
//                     </div>
//                     <div className="right-side">
//                       <img src={avatar} alt="" />
//                       <div className="content-wrapper">
//                         <div className="phone-number">{item.phoneNumber}</div>
//                         <div className="message-text">{formatData(typeof item.message === 'string' ? item.message : "" , typeof filterText === 'string' ? filterText : "",  typeof filterCity?.value === 'string' ? filterCity?.value : "")}</div>
//                         <div className="message-text">{moment(item.messageSentTime).format('LLL')}</div>
//                       </div>
//                       {
//                         yukBulSelectedMessages.map(item => item.id).includes(item.id) &&
//                         <div className="activator"></div>
//                       }
//                     </div>
//                   </div>
//                 );
//               })
//             }
//           </div>
//         </div>
//       </div>
//     </Container>
//   );
// }

// export default YukBul;

import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { getYukbulMessages, getYukbulMessagesCount, setYukBulSelectedMessages } from "../../features/admin5/admin5Slice";
import { useSelector } from "react-redux";
import avatar from "../../images/img/avatar.jpg"
import moment from "moment";
import Btn from "../../components/shared/button/Btn";
import { BsCheckLg } from "react-icons/bs";
import { clearPhoneNumbersForNotification } from "../../features/admin4/admin4Slice";
import { showModal } from "../../features/modal/modalSlice";
import InputSelectCity from "../../components/shared/input/new/InputSelectCity";
import InputText from "../../components/shared/input/new/InputText";

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .content {
      width: calc(100% - 60px);
      margin: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .top-container{
        width: 80%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        color: ${({theme}) => theme.mainTextColor};
        margin-bottom: 20px;

        .filter-grp{
            display: flex;
            align-items: center;
            gap: 20px;
            
            .left-side{
                padding: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 60px;
                height: 60px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                
            }
        }

        .right-side{
            display: flex;
            align-items: center;
            gap: 20px;

            .info-text{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }

        }
      }

      .list{
        width: 80%;
        display: flex;
        flex-direction: column;
        gap: 10px;
        color: ${({theme}) => theme.mainTextColor};


        .list-item{
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;
            border-radius: 10px;

            .left-side{
                padding: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 60px;
                height: 60px;

                .check-container{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 25px;
                    height: 25px;
                    border-radius: 50%;
                    border: 1px solid ${({theme}) => theme.secondaryTextColor};
                    background-color: ${({theme}) => theme.mainBgColor};

                    .check-icon{
                        font-size: 1rem;
                        color: ${({theme}) => theme.secondaryTextColor};
                    }
                }

                
                .active-check-container{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 25px;
                    height: 25px;
                    border-radius: 50%;
                    border: 1px solid var(--color-main);
                    background-color: var(--color-main);

                    .check-icon{
                        font-size: 1rem;
                        color: #fff;
                    }
                }

            }

            .right-side{
                width: calc(100% - 60px);
                display: flex;
                align-items: center;
                gap: 10px;
                background-color: ${({theme}) => theme.secondaryBgColor};
                padding: 20px;
                border-radius: 10px;
                position: relative;

                img{
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    object-fit: cover;
                }

      
                .content-wrapper{
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    color: ${({theme}) => theme.mainTextColor};
                    
                    .phone-number{
                        font-size: 13px;
                        font-weight: var(--font-weight-xl);
                        color: var(--color-main);
                    }
                    
                    .message-text{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                    }

                    .date{
                        font-size: 13px;
                        font-weight: var(--font-weight-lg);

                    }
                }

                .activator{
                    position: absolute;
                    height: 100%;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    width: 8px;
                    background-color: var(--color-main);
                    border-top-right-radius: 10px;
                    border-bottom-right-radius: 10px;
                }
            }
        }
      }

      }
  }
`;

// const formatData = (data) => {
//     return data
//         .split("\r\n") // Satırları ayır
//         .map(line => line.trim()) // Boşlukları temizle
//         .filter(line => line && line !== "_________") // Boş satırları ve gereksiz çizgileri çıkar
//         .map((line, index) => <p key={index}>{line}</p>); // JSX içine çevir
// };

const highlightText = (text, searchTerms) => {
  // if (typeof text !== 'string' || !searchTerms || searchTerms.length === 0) return text; // Eğer text string değilse veya searchTerms boşsa orijinal metni döndür

  // `searchTerms` içinde her iki arama terimini vurgulayacağız.
  let highlightedText = text;
  console.log(searchTerms);

  const filtered = searchTerms.filter(item => item !== "")
  

  filtered.forEach((search) => {
    const regex = new RegExp(`(${search})`, 'gi'); // 'gi' global ve case-insensitive
    highlightedText = highlightedText.replace(regex, (match) => `<span style="background-color: yellow">${match}</span>`);
  });

  return highlightedText;
};

const formatData = (data, filterText, filterCity) => {
  // if (typeof data !== 'string') data = String(data); // Mesajın string olduğundan emin olalım

  // Hem filterText hem de filterCity'yi vurgulamak için
  const searchTerms = [filterText?.toLocaleLowerCase("tr"), filterCity?.toLocaleLowerCase("tr")]; // Arama kelimelerini bir array'de toplayalım
  const formattedText = highlightText(data?.toLocaleLowerCase("tr"), searchTerms); // İki kelimeyi aynı anda vurgulamak için

  return <span dangerouslySetInnerHTML={{ __html: formattedText }} />;
};



const YukBul = () => {

    const dispatch = useDispatch()

    const {allYukbulMessages, yukBulSelectedMessages, isLoadingGetYukbulMessages, allYukbulMessagesCount} = useSelector(state => state.admin5)

    const [filterCity, setFilterCity] = useState(null)
    const [filterText, setFilterText] = useState(null)

    const observer = useRef();

    useEffect(() => {
        // İlk 200 öğeyi getiren API isteği

        dispatch(getYukbulMessages({
          size: 200,
          filterCity: filterCity?.value,
          filterText: filterText,
        }));
        dispatch(getYukbulMessagesCount({
            filterCity: filterCity?.value,
            filterText: filterText,
        }));
      }, [dispatch, filterCity, filterText]);

  // Intersection Observer ile infinite scroll
  const lastItemElementRef = useCallback(node => {
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && !isLoadingGetYukbulMessages && allYukbulMessagesCount > allYukbulMessages.length) {
        dispatch(getYukbulMessages({
          size: ((allYukbulMessages.length / 200) + 1) * 200,
          filterCity: filterCity?.value,
          filterText: filterText,
        }));
        dispatch(getYukbulMessagesCount({
            filterCity: filterCity?.value,
            filterText: filterText,
        }));
      }
    });

    if (node) observer.current.observe(node);
  }, [dispatch, isLoadingGetYukbulMessages, allYukbulMessages.length, filterCity, filterText, allYukbulMessagesCount]);


  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Yük Bul"} position="sticky" />
      <div className="content">
        <div className="top-container">
            <div className="filter-grp">
                <div className="left-side">Seç</div>
                <InputSelectCity data={filterCity?.value} setData={setFilterCity} name={"filterCity"} labelText={"İle Göre Filtrele"} />
                <InputText data={filterText} setData={(e) => setFilterText(e.target.value)} name={"workCity"} labelText={"Metne Göre Filtrele"} />
            </div>
            <div className="right-side">

                {
                    yukBulSelectedMessages.length > 0 ?
                    <>
                        <Btn bgColor="var(--color-main)" width={"220px"} handleClick={() => {dispatch(showModal("yukBulShareMessages")); dispatch(clearPhoneNumbersForNotification())}}>Seçilen Mesajları Paylaş</Btn>
                        <Btn bgColor="flex" color="flex" width={"220px"} borderColor="var(--color-main)" handleClick={() => {dispatch(showModal("yukBulDeletePermission"))}}>Seçilen Mesajları Sil</Btn>
                    </>
                    :
                    <div className="info-text">Paylaşmak veya silmek için mesaj seçin.</div>
                }
            </div>
        </div>
        <div className="list">
            {
                allYukbulMessages.map((item, index) =>  {
                    if(index === allYukbulMessages.length -1 ){
                        return (
                            <div
                                className="list-item"
                                ref={lastItemElementRef} 
                                key={index}>
                                <div className="left-side">
                                    <button className={yukBulSelectedMessages.map(item => item.id).includes(item.id) ? "active-check-container" : "check-container"} onClick={() => dispatch(setYukBulSelectedMessages({id: item.id}))}>
                                    <BsCheckLg className="check-icon"/>
                                    </button>
                                </div>
                                <div className="right-side">
                                    <img src={avatar} alt="" />
                                    <div className="content-wrapper">
                                        <div className="phone-number">{item.phoneNumber}</div>
                                        <div className="message-text">{formatData(typeof item.message === 'string' ? item.message : "" , typeof filterText === 'string' ? filterText : "",  typeof filterCity?.value === 'string' ? filterCity?.value : "")}</div>
                                        <div className="message-text">{moment(item.messageSentTime).format('LLL')}</div>
                                    </div>
                                    {
                                        yukBulSelectedMessages.map(item => item.id).includes(item.id) && 
                                        <div className="activator"></div>
                                    }
                                </div>
                            </div>
                        )
                    }
                    else{
                        return (
                            <div
                                className="list-item"
                                key={index}
                                >
                                <div className="left-side">
                                    <button className={yukBulSelectedMessages.map(item => item.id).includes(item.id) ? "active-check-container" : "check-container"} onClick={() => dispatch(setYukBulSelectedMessages({id: item.id}))}>
                                    <BsCheckLg className="check-icon"/>
                                    </button>
                                </div>
                                <div className="right-side">
                                    <img src={avatar} alt="" />
                                    <div className="content-wrapper">
                                        <div className="phone-number">{item.phoneNumber}</div>
                                        <div className="message-text">{formatData(typeof item.message === 'string' ? item.message : "" , typeof filterText === 'string' ? filterText : "",  typeof filterCity?.value === 'string' ? filterCity?.value : "")}</div>
                                        <div className="message-text">{moment(item.messageSentTime).format('LLL')}</div>
                                    </div>
                                    {
                                        yukBulSelectedMessages.map(item => item.id).includes(item.id) && 
                                        <div className="activator"></div>
                                    }
                                </div>
                            </div>
                        )
                    }
                })
            }
        </div>

        {/* {(adminDriverJobSeekerList && adminDriverJobSeekerList?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )} */}
      </div>
    </div>
  </Container>
  )
}

export default YukBul
